import { useMemo } from "react";
import { useParams as _useParams } from "react-router-dom";

export function useParams<P extends Record<string, string | undefined>>() {
  const params = _useParams<P>();

  return useMemo(() => params, [params]);
}
